import Vue from 'vue';
import axios from 'axios';

// 配置baseURL
const serverAddress = {
    // 生产环境服务器地址 https://shuttle.pandabus.cn:18092/
	// 青岛测试地址：http://124.229.182.201:8880/
    production: 'https://app.qjsggqczgs.top:8880/',
    // 开发环境服务器地址 http://zbapp.develop.pandabus.cc:40001/
    development: 'https://app.qjsggqczgs.top:8880/',
};
// 通过 process.env.NODE_ENV 来判断当前运行环境
axios.defaults.baseURL = serverAddress[process.env.NODE_ENV];


// 拦截所有请求
axios.interceptors.request.use((request) => {
	console.log(request)
	console.log(request.data)
	if (request.data!=undefined) {
		if (request.data.reqType=='CommonInformationGain') {
			request.baseURL = 'https://app.qjsggqczgs.top:8880/';
		}
	}
    request.headers = {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
	// var data1 = JSON.parse(request.data)
	// console.log(data1)
    if (request.url.indexOf('/weather/')==0) {
		request.baseURL = 'https://adapi.pandabus.cn:7800';
        request.headers = {
            'token': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJwYW5kYSJ9.3ha-nen4E9vhLf4RdhZVCHtvadhR-lAApodfoOxYr7M',
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
	}
	if (request.url.indexOf('/search')==0) {
		request.baseURL = 'https://app.qjsggqczgs.top:8880/';
	}
    // 如果包含本地测试数据的请求地址
    // if ('test-json-data'.indexOf(request.url)) {
    //     // 将本次请求的 baseURL 临时替换
    //     request.baseURL = 'http://localhost:8090/static';
    //     return request;
    // }

    // 除登录的请求地址以外所有请求都添加 account_token;
    // let token = Vue.prototype.$localStorage.getItem('token');
    // request.headers.Authorization = token;
    return request;
}, (err) => {
    return Promise.reject(err);
});


// 拦截所有响应
axios.interceptors.response.use((response) => {
    return response;
}, (err) => {
    return Promise.reject(err);
});

// 添加到 Vue原型链
Vue.prototype.$axios = axios;



// WEBPACK FOOTER //
// ./src/assets/js/$axios.js